module.exports = __webpack_public_path__ + "static/media/28.81f4b560.png";